/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
import deleteBankDetails from '../../actions/setupBankDetails.actions/deleteUserBankDetails';

/**
 * @class DebitAccountCard
 */
class DebitAccountCard extends React.Component {

  /**
   *
   * @param {*} bankId
   * @returns {*} - state
   */
  onDeleteBank = (bankId) => {
    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;
    const bankDetails = {
      customerId: Number(customerId),
      accountId: Number(bankId)
    };
    const { DeleteBankDetails } = this.props;
    DeleteBankDetails(bankDetails);
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      src,
      accountNumber,
      accountName,
      bankName,
      value,
      defaultChecked,
      onChange,
      name,
      bankId
    } = this.props;

    return (
      <div className="card_options my-3 p-4 available_card selected_bank">
        <div>
          <div className="card_icon">
            <img src={src} alt="" />
          </div>
          <div className="card_name">
            <h6>
              {accountNumber}
              {' '}
    -
              {' '}
              {accountName}
            </h6>
            <p>
              {bankName}
            </p>
          </div>
        </div>
        <div>
          <label className="content">
            <input
              type="radio"
              name={name}
              value={value}
              defaultChecked={defaultChecked}
              onChange={onChange}
            />
            <span className="checkmate" />
          </label>
        </div>
        <div style={{ marginTop: '10px' }}>
          <button type="button"
            onClick={() => this.onDeleteBank(bankId)}
          >
            <i className="fas fa-trash" style={{
              color: 'red',
              cursor: 'pointer',
            }}
            />
          </button>
        </div>
      </div>
    );
  }
}

DebitAccountCard.propTypes = {
  src: PropTypes.string,
  accountNumber: PropTypes.any,
  accountName: PropTypes.string,
  bankName: PropTypes.string,
  value: PropTypes.number,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  DeleteBankDetails: PropTypes.func,
  bankId: PropTypes.any,

};

export default connect(null, {
  DeleteBankDetails: deleteBankDetails
})(DebitAccountCard);
